<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader style="border-bottom: 0">
						Gestion des palettes
						<hr />
						<div class="card-header-left-actions">
							<CButton color="primary" v-on:click="previousPage"> << Précédent </CButton>
						</div>
						<div class="card-header-actions">
							<CButton color="primary" v-on:click="showAddModal"> + Ajouter </CButton>
						</div>
					</CCardHeader>

					<CCardBody>
						<GDataTableRemote
							ref="mainTable"
							:remote-url="`/api/flights/${this.$route.query['flight']}/pallets`"
							:fields="fields"
							:items-per-page="10"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #type="{ item }">
								<td>
									{{ item.type === 'OTHER' ? 'Autre' : item.type }}
								</td>
							</template>
							<!-- TODO: Handle state
                            <template #state="{item}">
                              <td>
                                <CBadge :color="stateColors[item.state]" >{{ item.translatedState }}</CBadge>
                              </td>
                            </template>
                            -->

							<template #actions="{ item }">
								<td class="text-center">
									<a
										class="text-center icon-space"
										href="#"
										@click.prevent="showEditModal(item)">
										<CIcon name="cil-pencil" />
									</a>
									<a
										class="text-center icon-space"
										href="#"
										@click.prevent="showDeleteNotify(item)">
										<CIcon name="cil-trash" />
									</a>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>

		<AddModal ref="addModal" v-on:refresh="refresh()" />
		<ModifyModal ref="modifyModal" v-on:refresh="refresh()" />
	</div>
</template>
<script>
	import GDataTableRemote from '../../../../../components/ghostlexly-components/GDataTableRemote';
	import AddModal from './AddPallet';
	import ModifyModal from './ModifyPallet';
	import router from '../../../../../router';

	export default {
		components: {
			GDataTableRemote,
			AddModal,
			ModifyModal,
		},

		data() {
			const states = [
				{ value: 'pallet.pending', label: 'En attente' },
				{ value: 'pallet.filling_in_progress', label: 'Remplissage en cours' },
				{ value: 'pallet.filled', label: 'Rempli' },
			];
			return {
				flight: null,
				fields: [
					{ key: 'reference', label: 'Numéro de palette' },
					{ key: 'type', label: 'Type de palette' },
					// { key: 'state', label: 'Statut', type: 'select', filterSelectOptions: states },
					{ key: 'weightLimit', label: 'Limite poids' },
					{ key: 'volumeLimit', label: 'Limite volume' },
					{ key: 'quantityLimit', label: 'Limite quantité' },
					{ key: 'actions', filter: false },
				],
				stateColors: {
					'pallet.pending': 'info',
					'pallet.filling_in_progress': 'warning',
					'pallet.filled': 'success',
				},
				activePage: 1,
			};
		},

		methods: {
			showAddModal: function () {
				this.$refs.addModal.showModal = true;
			},
			showEditModal: function ($pallet) {
				this.$refs.modifyModal.pallet = $pallet;
				this.$refs.modifyModal.showModal = true;
			},
			previousPage: function () {
				router.go(-1);
			},
			showDeleteNotify: function (item) {
				if (confirm('Est-ce que vous êtes sûr de vouloir supprimer cette palette ?')) {
					this.$axios.delete(`/api/pallets/${item.id}`).then(res => {
						this.$toast.success(`La palette ${item.reference} a bien été supprimée`);
						this.$refs.mainTable.refresh();
					});
				}
			},
			refresh: function () {
				this.$refs.mainTable.refresh();
			},
		},
	};
</script>
<style>
	.icon-space {
		margin-right: 10px;
	}

	.badge-warning {
		color: white;
	}
</style>
